import Share from "./Share";

export default Share;
